export const errorStatusContent = {
  400: {
    title: '400',
    subtitle: 'error:400_title',
    message: 'error:400_description',
  },
  401: {
    title: '401',
    subtitle: 'error:401_title',
    message: 'error:401_description',
  },
  403: {
    title: '403',
    subtitle: 'error:403_title',
    message: 'error:403_description',
  },
  404: {
    title: '404',
    subtitle: 'error:404_title',
    message: 'error:404_description',
  },
  429: {
    title: '429',
    subtitle: 'error:429_title',
    message: 'error:429_description',
  },
  default: {
    title: 'Ops!',
    subtitle: 'error:client_error_title',
    message: 'error:client_error_description',
  },
  500: {
    title: '500',
    subtitle: 'error:500_title',
    message: 'error:500_description',
  },
} as const;
